import { Link as RouterLink, LinkProps } from 'react-router-dom';
import { useCurrentLanguage } from './LanguageRedirect';

/**
 * Language-aware Link component that automatically adds the current language prefix
 * Usage: <LanguageLink to="/tools/calculator">Text</LanguageLink>
 * Result: Links to /{currentLang}/tools/calculator
 */
export function LanguageLink({ to, ...props }: LinkProps) {
  const currentLang = useCurrentLanguage();
  
  // Don't add prefix if it's already there or if it's an external link
  const href = typeof to === 'string' 
    ? (to.startsWith('http') || to.startsWith(`/${currentLang}/`) 
        ? to 
        : `/${currentLang}${to.startsWith('/') ? to : `/${to}`}`)
    : to;

  return <RouterLink to={href} {...props} />;
}
